import React from 'react'
import Button from './Button';
import Service from './Service';
import svcIcon1 from '../img/services/svc_icon1.svg'
import svcIcon2 from '../img/services/svc_icon2.svg'
import svcIcon3 from '../img/services/svc_icon3.svg'
import svcIcon4 from '../img/services/svc_icon4.svg'
import svcIcon5 from '../img/services/svc_icon5.svg'
import svcIcon6 from '../img/services/svc_icon6.svg'
import svcIcon7 from '../img/services/svc_icon7.svg'
import svcIcon8 from '../img/services/svc_icon8.svg'
import logo from '../img/logo-element.svg'

const servicesList = [
  { id: 1, img: svcIcon1, title: 'Smart Contract Development & Audit', text: 'Secure, transparent, and optimized blockchain solutions' },
  { id: 2, img: svcIcon2, title: 'Decentralized Applications (dApps)', text: 'From idea to scalable Web3 products' },
  { id: 3, img: svcIcon3, title: 'Web3 Ecosystem Integration', text: 'Empowering your business with Web3 technologies' },
  { id: 4, img: svcIcon4, title: 'Token Development & Launch Support', text: 'From concept to listing — your token, ready for the market.' },
  { id: 5, img: svcIcon5, title: 'Full Project Lifecycle Management', text: 'From concept to launch — we handle it all.' },
  { id: 6, img: svcIcon6, title: 'Security-First Web3 Consulting', text: 'Expert consulting and implementation of secure, scalable, and transparent Web3 solutions.' },
  { id: 7, img: svcIcon7, title: 'Web2 Development and Integration', text: 'Building and integrating modern web applications with a focus on performance and reliability.' },
  { id: 8, img: svcIcon8, title: 'Website Development, Custom software development, UX/UI for any business', text: 'Creating websites, custom software, and intuitive UX/UI tailored to your business needs.' }
];

export default function Services() {
  return (
    <div className='services'>
      <div className='container'>
        <div className='services-title'>
            <h2>Development Services</h2>
        </div>
        <div className='services-list'>
            {servicesList.map((service) => (
              <Service key={service.id} img={service.img} title={service.title} text={service.text}/>
            ))}
        </div>
        <div className='services-btn'>
          <Button cls='button-primary' />
        </div>
        <img className='services-logo' src={logo} alt='logo'/>
      </div>
    </div>
  )
}
